import { Alert, AlertTitle, Button, ListItem, UnorderedList } from '@chakra-ui/react';
import { useInvestorAccountModel } from '@common/models/InvestorAccountModel';
import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from 'src/apps/invest/config';

export const Eligibility: React.FC = () => {
  const investorModel = useInvestorAccountModel();
  return (
    <Alert
      status="info"
      alignItems={'flex-start'}
      justifyContent="center"
      flexDirection={'column'}
      gap="10px"
      marginBottom={'10px'}
      variant="left-accent">
      <AlertTitle>
        We still need the following information from you before you can invest in SFR. Follow the wizard on the
        Dashboard to complete your profile.
      </AlertTitle>
      <UnorderedList style={{ listStyle: 'inside', marginBottom: 10 }}>
        {investorModel.sfrEligibility?.needsBankAccount && <ListItem>Bank Account</ListItem>}
        {investorModel.sfrEligibility?.needsToFillOutAnnualIncome && <ListItem>Annual Income</ListItem>}
        {investorModel.sfrEligibility?.needsToFillOutNetWorth && <ListItem>Net Worth</ListItem>}
        {investorModel.sfrEligibility?.needsToFillOutExperienceSurvey && <ListItem>Experience Information</ListItem>}
        {investorModel.sfrEligibility?.needsToFillOutObjectivesSurvey && <ListItem>Objectives Information</ListItem>}
      </UnorderedList>
      <Button
        as={Link}
        to={ROUTES.dashboard}
        variant="outline"
        colorScheme={'info'}
        size={'lg'}
        borderColor="info.500"
        color="info.600"
        width="100%">
        Dashboard
      </Button>
    </Alert>
  );
};
